import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Package, Truck } from 'lucide-react';

const LogisticsPromo = () => {
  const navigate = useNavigate();

  const vehicleTypes = [
    { emoji: '🛻', name: 'Pickup Truck', capacity: 'Up to 1 ton' },
    { emoji: '🚚', name: 'Mini Truck', capacity: '1-3 tons' },
    { emoji: '🚛', name: 'Large Truck', capacity: '5+ tons' },
    { emoji: '🚐', name: 'Cargo Van', capacity: 'Small loads' }
  ];

  return (
    <div className="py-16 px-4 bg-gradient-to-r from-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">
              <Truck className="h-4 w-4" />
              New Feature
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
              Need to ship cargo?
              <br />
              <span className="text-orange-600">Tekstar Logistics</span>
            </h2>
            <p className="text-xl text-gray-600">
              Transport goods of any size - from small packages to heavy cargo. 
              Book pickup trucks, mini trucks, or large trucks instantly.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => navigate('/logistics')}
                className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg font-semibold rounded-xl"
                data-testid="book-logistics-btn"
              >
                <Package className="mr-2 h-5 w-5" />
                Book Cargo Transport
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/operator/login')}
                className="px-8 py-6 text-lg font-semibold rounded-xl border-orange-300 text-orange-700 hover:bg-orange-50"
                data-testid="become-operator-btn"
              >
                <Truck className="mr-2 h-5 w-5" />
                Become an Operator
              </Button>
            </div>
          </div>
          <div className="hidden lg:block">
            <div className="grid grid-cols-2 gap-4">
              {vehicleTypes.map((vehicle, idx) => (
                <div key={idx} className="bg-white rounded-xl p-6 shadow-lg border border-orange-100">
                  <div className="text-4xl mb-4">{vehicle.emoji}</div>
                  <h3 className="font-semibold text-gray-900">{vehicle.name}</h3>
                  <p className="text-sm text-gray-600">{vehicle.capacity}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogisticsPromo;
